// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Multiselect_checkbox__26y_u","item":"Multiselect_item__1pfif","content":"Multiselect_content__qlkR9"};